import axios from 'axios'
import { API_ADDRESS } from 'config'
import { OwnerConfig } from 'config/constants/types'
import { CouncilsSuburb } from 'state/types'
import { checkToken } from 'utils/functions'

const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
const config = {
	method: 'GET',
	headers: {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${tokenData?.token}`,
	},
}

export const getSuburbStats = async (ownerId: string): Promise<any[]> => {
  try{
    const params = window.location.href.includes('broken-listings') || window.location.href.includes('broken-listings') ? `ownerId=${ownerId}&showBroken=true` : `ownerId=${ownerId}`;
    const response = await fetch( `${API_ADDRESS}/admin/councils/list-suburbs?${params}`, config)
    const data = await response.json()
    checkToken(data)
    return data
  } catch(err){
    return []
  }
}

export const getSuburbsCsv = async (ownerId: string): Promise<any[]> => {
  const customConfig = {
    ...config,
    method: 'POST',
  }
  try{
    const response = await fetch( `${API_ADDRESS}/admin/councils/csv-suburbs-listings?ownerId=${ownerId}`, customConfig)
    const data = await response.json()
    checkToken(data)
    return data
  } catch(err){
    return []
  }
}

export const getSuburbOwner = async (ownerId: string): Promise<any> => {
  try{
    const response = await fetch( `${API_ADDRESS}/admin/get-owner?ownerId=${ownerId}`, config)
    const data = await response.json()
    checkToken(data)
    return data
  } catch(err){
    return []
  }
}

export const updateSuburbStats = async (ownerId: string): Promise<any> => {
  try{
    const response = await fetch( `${API_ADDRESS}/stats/create-owner/${ownerId}`, config)
    const data = await response.json()
    checkToken(data)


    // New Update Council Dashboard Stats at same time
    try {
      const dashboardResponse = await fetch(`${API_ADDRESS}/admin/councils/dashboard-set?ownerId=${ownerId}`);
    } catch(err) {
      console.log("Error setting council dashboard", err);
    }

    return data
  } catch(err){
    return []
  }
}
